export default __webpack_public_path__ + "static/media/mspnavicon.942b6140.png";